<template>
  <div>
    <el-card class="box-card halwidth">
      <div slot="header" class="clearfix">
        <div style='display:inline-block;'>
          <el-date-picker
              v-model="startDate"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"	
              >
          </el-date-picker>
          <el-date-picker
              v-model="endDate"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"	
              >
          </el-date-picker>
        </div>  
      </div>
      <div>
        <div @click="download('sd')" class="download">下载会员各阶省代统计</div>
        <div @click="download('unpaypoints')" class="download">下载会员未兑换积分</div>
        <div @click="download('allpoints')" class="download">下载会员所有积分</div>
        <div @click="download('group')" class="download">下载团队会员数据</div>
        <div @click="download('sale')" class="download">下载公司订货数据</div>
        <div @click="download('yeji')" class="download">下载当月业绩数据</div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {download} from '@/api'

export default {
  name: 'download',
  data(){
     return {
        startDate:'',
        endDate:'',
     }
  },
  methods: {
    download(type){
        switch(type){
            case 'sd':
               download("/download/downloadSd",{startDate:this.startDate,endDate:this.endDate})
               break;
            case 'unpaypoints':
               download("/download/downloadPoints",{startDate:this.startDate,endDate:this.endDate})  
               break;
            case 'allpoints':
               download("/download/downloadAllPoints",{startDate:this.startDate,endDate:this.endDate})      
               break;
            case 'group':
                this.$prompt('请输入领导人会员名或手机号码', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                }).then(({ value }) => {
                      if(value==''||value==undefined){
                         this.$message.error("请输入内容");return false;
                      }
                      download("/download/group",{keywords:value})     
                });   
                break;
            case 'sale':
               download("/download/sale",{startDate:this.startDate,endDate:this.endDate})  
               break;   
               
            case 'yeji':
               download("/download/yeji",{startDate:this.startDate,endDate:this.endDate})  
               break;   
            default:
              break;   
        }
     }
  }
}
</script>

<style scoped lang="scss">
.download{color:#409EFF;cursor: pointer;margin-bottom:15px;font-size:14px;}
.download:hover{text-decoration: underline;}
.halwidth{width:50%;}
</style>
